import React from 'react';

import { DebtTableStatus } from '../model/enums/debt-status.enum';
import { PaymentHistoryStatus } from '../model/enums/payment-history-status.enum';

export type StatusOptionItem = {
  value: string;
  label: React.ReactNode;
};

export const buildPaymentStatusOptions = (
  t: (key: string, vars?: Record<string, any>) => React.ReactNode,
): StatusOptionItem[] => [
  { value: 'all', label: t('users_eco_fee.common.all') },
  { value: PaymentHistoryStatus.PENDING, label: t('users_eco_fee.payments.status_pending') },
  { value: PaymentHistoryStatus.SUCCESSFUL, label: t('users_eco_fee.payments.status_successful') },
];

export const buildDebtStatusOptions = (
  t: (key: string, vars?: Record<string, any>) => React.ReactNode,
): StatusOptionItem[] => [
  { value: 'all', label: t('users_eco_fee.common.all') },
  { value: DebtTableStatus.PENDING, label: t('users_eco_fee.common.pending') },
  { value: DebtTableStatus.CANCELLED, label: t('users_eco_fee.common.cancelled') },
];
